import { render, staticRenderFns } from "./user.vue?vue&type=template&id=453dcb8c&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style1 from "./user.vue?vue&type=style&index=1&id=453dcb8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453dcb8c",
  null
  
)

export default component.exports